import QuestionSelect from './view';

export default QuestionSelect;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/select/index.js